
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { Row, Col, Button, Table, Popover } from 'antd';
import { SearchOutlined, MenuOutlined } from '@ant-design/icons';
import TripEditWhereAddress from './TripEditWhereAddress'

const DragHandle = SortableHandle(() => (
    <MenuOutlined
        style={{
            cursor: 'grab',
            color: '#999',
        }}
    />
));


const SortableItem = SortableElement((props) => <tr {...props} />);
const SortableBody = SortableContainer((props) => <tbody {...props} />);

class TripEditWhere extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalAddress: false,
            selectedType: null,
            selectedRoute: null,
            selectedIndex: null,
            addresses: []
        };
    }

    componentWillMount() {
        this.getAddress()
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        if (oldIndex !== newIndex) {
            this.props.moveWayPoint(oldIndex, newIndex)
        }
    };

    DraggableContainer = (props) => (
        <SortableBody
            useDragHandle
            disableAutoscroll
            helperClass="row-dragging"
            onSortEnd={this.onSortEnd}
            {...props}
        />
    );

    DraggableBodyRow = ({ className, style, ...restProps }) => {
        const index = this.props.routes.filter(x => x.type === "WayPoint").findIndex((x) => x.address === restProps['data-row-key']);
        return <SortableItem index={index} {...restProps} />;
    };

    onToggleAddressModal = (selectedType, selectedRoute, selectedIndex) => {

        if (selectedType === "WayPoint") {
            this.setState({ isModalAddress: !this.state.isModalAddress, selectedType, selectedRoute, selectedIndex });
        } else if (selectedType) {
            this.setState({ isModalAddress: !this.state.isModalAddress, selectedType, selectedRoute });
        } else {
            this.setState({ isModalAddress: !this.state.isModalAddress, selectedRoute });
        }
    }

    getAddress = () => {

        let endpoint = { keyOne: "addresses" };

        this.props.dispatch(actions.definitions.getData({
            ...endpoint
        })).then(response => {
            this.setState({
                addresses: response.data
            });
        })
    }

    renderColumns = ()=>{

        const columns = [
            {
                title: 'Sort',
                dataIndex: 'sort',
                width: 30,
                className: 'drag-visible',
                render: () => <DragHandle />,
            },
            {
                title: 'address',
                dataIndex: 'address',
                key: 'address',
                className: 'drag-visible',
                render: (text, record, rowIndex) => (
                    <Popover content={
                        <div className='items'>
                            <div className='item' onClick={()=> this.onToggleAddressModal("WayPoint", record, rowIndex)} >Düzenle</div>
                            <div className='item' onClick={()=> this.props.deleteWayPoint(rowIndex)}>Sil</div>
                        </div>
                    }
                        placement='bottom'
                        trigger="click"
                        overlayClassName='trip-way-point-popover'
                    >
                        <div className='address'>
                            {record.address}
                        </div>
                    </Popover>
                )
            },
        ]

        return columns;
    }


    render() {

        let { isModalAddress, selectedType, selectedRoute, selectedIndex, addresses } = this.state;
        let { scrollToModule, routes } = this.props
        let startPoint = routes.find(x => x.type === "StartPoint")
        let endPoint = routes.find(x => x.type === "EndPoint")
        let waypoints = routes.filter(x => x.type === "WayPoint")

        return (

            <Fragment>
                <div className='module'>NEREDE, NEREYE?</div>
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <div className='label'>
                            <span>
                                NEREDEN?
                            </span>
                        </div>

                        <div className="box-with-icon"
                            onClick={() => this.onToggleAddressModal("StartPoint", startPoint)}
                        >
                            {startPoint &&
                                <Fragment>
                                    <SearchOutlined />
                                    <span className='select-address'>{startPoint.address}</span>
                                </Fragment>
                            }

                            {
                                !startPoint &&
                                <Fragment>
                                    <SearchOutlined />
                                    <span className='select-address'>Bir adres seçebilirsiniz</span>
                                </Fragment>
                            }

                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <div className='label-waypoint'>
                            <span>
                                UĞRAK NOKTA
                            </span>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>

                        {
                            waypoints.length > 0 &&

                            <Table
                                className='waypoint-items'
                                pagination={false}
                                dataSource={waypoints}
                                columns={this.renderColumns()}
                                rowKey="address"
                                showHeader={false}
                                components={{
                                    body: {
                                        wrapper: this.DraggableContainer,
                                        row: this.DraggableBodyRow,
                                    },
                                }}
                                onRow={(record, rowIndex) => {
                                    return {
                                        onClick: event => {
                                            // this.onToggleAddressModal("WayPoint", record, rowIndex)
                                        },
                                    };
                                }}
                            />
                        }
                    </Col>
                </Row>

                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <div className="move-action"
                            onClick={() => this.onToggleAddressModal("WayPoint")}
                        >
                            <div className="image">
                                <strong>+</strong>
                            </div>
                            <div className="text">
                                <h3>VARSA, UĞRAK NOKTA GİRİNİZ</h3>
                                <p>Kalkış ve varış dışında uğrak başka noktalar ekleyebilirsiniz</p>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <div className='label'>
                            <span>
                                NEREYE?
                            </span>
                        </div>

                        <div className="box-with-icon"
                            onClick={() => this.onToggleAddressModal("EndPoint", endPoint)}

                        >
                            {endPoint &&
                                <Fragment>
                                    <SearchOutlined />
                                    <span className='select-address'>{endPoint.address}</span>
                                </Fragment>
                            }

                            {
                                !endPoint &&
                                <Fragment>
                                    <SearchOutlined />
                                    <span className='select-address'>Bir adres seçebilirsiniz</span>
                                </Fragment>
                            }
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Button
                            htmlType="submit"
                            type="default"
                            className="ant-btn width-100"
                            style={{ float: "right", height: 40, marginTop: 25, marginRight: 10 }}
                            onClick={(e) => scrollToModule("withWho")}
                        >
                            Önceki
                        </Button>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Button
                            htmlType="submit"
                            type="primary"
                            className="ant-btn width-100"
                            style={{ float: "right", height: 40, marginTop: 25 }}
                            onClick={(e) => scrollToModule("other")}
                        >
                            Devam
                        </Button>
                    </Col>
                </Row>

                {
                    isModalAddress &&
                    <TripEditWhereAddress
                        isModalAddress={isModalAddress}
                        handleToggle={this.onToggleAddressModal}
                        type={selectedType}
                        addRoute={this.props.addRoute}
                        selectedRoute={selectedRoute}
                        selectedIndex={selectedIndex}
                        addresses={addresses}
                    />
                }



            </Fragment>
        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripEditWhere);


// WEBPACK FOOTER //
// ./src/components/App/Views/Trip/TripEditWhere.js